import { render, staticRenderFns } from "./itemoption_simple.vue?vue&type=template&id=96ac30d2&scoped=true&"
import script from "./itemoption_simple.vue?vue&type=script&lang=js&"
export * from "./itemoption_simple.vue?vue&type=script&lang=js&"
import style0 from "./itemoption_simple.vue?vue&type=style&index=0&id=96ac30d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac30d2",
  null
  
)

export default component.exports